module.exports = __webpack_public_path__ + "static/madrinasinsurance-acb43eebcc8eebec5bf487cc29722c17.png";